import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import FormControl from '@material-ui/core/FormControl';
import { Typography } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import KenTextLabel from '../KenTextLabel/index';
import StatusErrorIcon from './assets/StatusErrorIcon.svg';
import StatusSuccessIcon from './assets/StatusSuccessIcon.svg';
import StatusWarningIcon from './assets/StatusWarningIcon.svg';
import { GLOBAL } from '../../utils/constants';
import KenColors from '../../themes/KenColors';
import { useTranslation } from 'react-i18next';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(2),
    },
  },
  input: {
    position: 'relative',
    backgroundColor: theme.palette.KenColors.neutral10,
    fontSize: 16,
    width: '100%',
    padding: '10px 12px',
    transition: theme.transitions.create(['border-color']),
    '&:focus': {
      borderColor: theme.palette.KenColors.primary,
    },
    '&:visited': {
      borderColor: theme.palette.KenColors.tertiaryGreen200,
    },
    '&:invalid': {
      color: theme.palette.KenColors.neutral60,
    },
    '&::-webkit-calendar-picker-indicator': {
      filter: 'invert(0.5)',
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    width: '100%',
  },
  labelWrap: {
    marginBottom: 2,
  },
  typoLabel: {},
  typoOption: {
    color: theme.palette.KenColors.neutral100,
  },
  typoSupporting: {
    fontSize: '12px',
    color: theme.palette.KenColors.neutral100,
    marginTop: 4,
  },
  inputBorderWarning: {
    border: `1px solid ${theme.palette.KenColors.tertiaryYellow300}`,
    borderRadius: 3,
  },
  inputBorderError: {
    border: `1px solid ${theme.palette.KenColors.tertiaryRed400}`,
    borderRadius: 3,
  },
  inputBorderSuccess: {
    border: `1px solid ${theme.palette.KenColors.tertiaryGreen300}`,
    borderRadius: 3,
  },
  inputBorder: {
    border: `1px solid ${theme.palette.KenColors.neutral40}`,
    borderRadius: 3,
  },
}));

export default function KenInputField(props) {
  const { t } = useTranslation();
  const {
    id,
    title,
    placeholder,
    disabled,
    label,
    value,
    required,
    onChange,
    onBlur,
    onFocus,
    autofocus,
    readonly,
    icon,
    name,
    errors,
    touched,
    optionalLabel = true,
    startAdornment,
    startAdornmentIcon,
    type,
  } = props;
  const classes = useStyles();

  const getErrorStatus = (type) => {
    let status, helpText;
    if (!touched) return;
    if (errors === GLOBAL.VALIDATIONS.REQ) {
      status = 'warning';
      helpText = (
        <span style={{ color: KenColors.tertiaryYellow400 }}>
          <img src={StatusWarningIcon} alt='warning'></img>{' '}
          {t('validations:standard_required')}
        </span>
      );
    } else if (errors) {
      status = 'error';
      helpText = (
        <span style={{ color: KenColors.tertiaryRed400 }}>
          <img src={StatusErrorIcon} alt='error'></img> {errors}
        </span>
      );
    }

    if (touched && !errors) {
      status = 'success';
      helpText = (
        <span style={{ color: KenColors.tertiaryGreen500 }}>
          <img src={StatusSuccessIcon} alt='success'></img>{' '}
          {t('validations:standard_success')}
        </span>
      );
    }

    if (type === GLOBAL.VALIDATIONS.STATUS.ERROR) {
      return helpText;
    }
    if (type === GLOBAL.VALIDATIONS.TYPE.STATUS) {
      switch (status) {
        case 'warning':
          return 'inputBorderWarning';
        case 'success':
          return 'inputBorderSuccess';

        case 'error':
          return 'inputBorderError';

        default:
          return 'inputBorder';
      }
    }
  };

  return (
    // <form className={classes.root} noValidate>

    <FormControl
      disabled={disabled || readonly}
      className={classes.formControl}
    >
      <KenTextLabel
        label={label}
        required={required}
        optionalLabel={optionalLabel}
      />
      <BootstrapInput
        {...props}
        className={classes[getErrorStatus('status') || 'inputBorder']}
        pattern='[A-Za-z]{3}'
        endAdornment={
          icon && <InputAdornment position='start'>{icon}</InputAdornment>
        }
        id={id}
        placeholder={placeholder}
        title={title}
        disabled={disabled || readonly}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        autoFocus={autofocus}
        required={required}
        name={name}
        type={type}
        startAdornment={startAdornment && startAdornmentIcon}
      />

      <Typography className={classes.typoSupporting} align='left'>
        {getErrorStatus('error')}
      </Typography>
    </FormControl>

    // </form >
  );
}
